import { render, staticRenderFns } from "./EpagWidget.vue?vue&type=template&id=1435c76f&shadow"
import script from "./EpagWidget.vue?vue&type=script&lang=ts&shadow"
export * from "./EpagWidget.vue?vue&type=script&lang=ts&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports